var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowStarJumpPopup
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "userStarJump" } }, [
          _c("div", { attrs: { id: "starJumpClose" } }, [
            _c("div", {
              staticClass: "icon-star-close",
              on: {
                click: function($event) {
                  return _vm.closeStarJumpPopup()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              id: "starJumpImg",
              src: require("../../../assets/images/userStar/thank-you.svg"),
              draggable: "false"
            }
          }),
          _vm._v(" "),
          _c("div", { attrs: { id: "starJumpTitle" } }, [
            _vm._v(_vm._s(_vm.$t("language.popup.userStarPopup.thankYou")))
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "starJumpDesc" } }, [
            _vm._v(_vm._s(_vm.$t("language.popup.userStarPopup.thankYouDesc")))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { id: "starJumpBtn" },
              on: {
                click: function($event) {
                  return _vm.jumpToTrustpilot()
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("language.popup.userStarPopup.reviewStart"))
              ),
              _c("span"),
              _vm._v(
                "Trustpilot " +
                  _vm._s(_vm.$t("language.popup.userStarPopup.reviewEnd"))
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-422c0612", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-422c0612","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/user_star_jump_popup.vue
// module id = null
// module chunks = 